function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLaptop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 491.519 491.519",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#ebf0f3"
  },
  d: "M448.502 82.74H43.016c-5.849 0-10.59 4.741-10.59 10.591v284.794h426.667V93.332c0-5.851-4.742-10.592-10.591-10.592z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#64798a"
  },
  d: "M57.733 108.032h376.064v244.782H57.733z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#3a556a"
  },
  d: "m57.731 352.825 376.057-244.781v244.781z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#d5d6db"
  },
  d: "M0 381.215v13.842c0 1.363.893 2.565 2.198 2.958l35.32 10.634c.288.087.588.131.891.131H453.11c.301 0 .601-.044.89-.131l35.32-10.634a3.09 3.09 0 0 0 2.199-2.958v-13.842a3.09 3.09 0 0 0-3.09-3.089H3.089A3.088 3.088 0 0 0 0 381.215z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#64798a"
  },
  d: "m205.942 378.126 3.868 7.079h71.898l3.868-7.079z"
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#64798a"
  },
  cx: 245.76,
  cy: 96.199,
  r: 6.426
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#3a556a"
  },
  cx: 245.76,
  cy: 96.199,
  r: 2.729
}));
export { SvgLaptop as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/laptop.svg";